import axiosInstance from "../axios";
import { infoAction } from "./slice";
import { CLIENT_INFO, V1API } from "../../utils/endPoints";
export const checkingVpn = function () {
  return async (dispatch: Function) => {
    try {
      const config = {
        url: `${V1API}${CLIENT_INFO}`,
        method: "GET",
        timout: 0,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      const response = await axiosInstance(config);
      dispatch(infoAction.checkVPN(response.data));
    } catch (error) {}
  };
};
